function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18768"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18742"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 243",
    width: 32,
    height: 32,
    rx: 16,
    style: {
      fill: "#55bc72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "check (2)",
    d: "m14 6-6.875 6.875L4 9.75",
    transform: "translate(7.786 6.471)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.8e30237af834e37061d8abc9ee932e85.svg";
export { ForwardRef as ReactComponent };